import { IconContent } from '@icons';

export const stack: IconContent = {
    sm: '<path d="m8 1 .252.147 5.758 3.357v.864L8.252 8.725 8 8.872l-.252-.147L1.99 5.368v-.864l5.758-3.357L8 1ZM3.235 4.936 8 7.715l4.766-2.779L8 2.157 3.235 4.936Zm11.207 6.308-.432.252-5.758 3.357L8 15l-.252-.147-5.758-3.357-.432-.252.504-.864.431.252L8 13.842l5.506-3.21.432-.252.504.864Zm-.432-2.812.432-.252-.504-.864-.432.252L8 10.778l-5.507-3.21-.431-.252-.504.864.432.252 5.758 3.357.252.147.252-.147 5.758-3.357Z" />',
};
